/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespEditorialModuleOld_homepage = {
    readonly editorialModule: {
        readonly items?: ReadonlyArray<{
            readonly cmsId: number | null;
            readonly cta: string | null;
            readonly description: string | null;
            readonly linkData: {
                readonly path: string | null;
                readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData" | "SeoButton_linkData">;
            };
            readonly imageUrl: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespEditorialModuleOld_homepage";
};
export type HpRespEditorialModuleOld_homepage$data = HpRespEditorialModuleOld_homepage;
export type HpRespEditorialModuleOld_homepage$key = {
    readonly " $data"?: HpRespEditorialModuleOld_homepage$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespEditorialModuleOld_homepage">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespEditorialModuleOld_homepage",
  "type": "Homepage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "editorialModule",
      "name": "module",
      "storageKey": "module(type:\"editorial\")",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "editorial"
        }
      ],
      "concreteType": null,
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "EditorialModule",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "items",
              "storageKey": null,
              "args": null,
              "concreteType": "EditorialItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cmsId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "cta",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "linkData",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LinkData",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "path",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoLink_linkData",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "SeoButton_linkData",
                      "args": null
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'edf25dd3899cc81487fc8d52a08338b1';
export default node;
